import { css } from '@emotion/react';

export const custom = css`
  display: block;
  max-width: 100%;
`;
